import React from 'react'
import {
  Grid,
  Typography,
  Link,
  Container,
  Box,
} from '@material-ui/core'
import footerClasses from './Footer.styles'
import { FooterProps } from './Footer'
import BackToTopButton from '../BackToTopButton/BackToTopButton'
import MediaImage from '../Media/MediaImage'

const classes = footerClasses.desktop

export default function DesktopFooter({
  company_column_title,
  company,
  help_column_title,
  help,
  social_column_title,
  social,
  address,
  logo,
  logo_alt_text,
  show_back_to_top,
  links_for_seo_title,
  links_for_seo,
}: FooterProps) {
  return (
    <Box>
      <Box p={4} className={classes.mainBox}>
        <Container>
          {show_back_to_top && (
            <Grid container justify="flex-end">
              <BackToTopButton className={classes.backToTop} />
            </Grid>
          )}
          <Box
            display="grid"
            gridTemplateColumns="repeat(4, 1fr)"
            gridColumnGap={8}
            gridRowGap={2}
            gridAutoFlow="row"
          >
            {/** Company */}
            <Box>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
                className={classes.menuTitle}
              >
                {company_column_title || 'Company'}
              </Typography>
              {company.map((link, index) => (
                <Box key={index} className={classes.links}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    gutterBottom
                  >
                    <Link href={link.url} color="textPrimary">
                      {link.text}
                    </Link>
                  </Typography>
                </Box>
              ))}
            </Box>
            {/** Help & Support */}
            <Box>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
                className={classes.menuTitle}
              >
                {help_column_title || 'Help & Support'}
              </Typography>
              {help.map((link, index) => (
                <Box key={index} className={classes.links}>
                  <Typography
                    variant="body2"
                    color="textPrimary"
                    gutterBottom
                  >
                    <Link href={link.url} color="textPrimary">
                      {link.text}
                    </Link>
                  </Typography>
                </Box>
              ))}
            </Box>
            {/** Social */}
            <Box className={classes.social}>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
                className={classes.menuTitle}
              >
                {social_column_title || 'Connect'}
              </Typography>
              <Box display="flex" flexWrap="wrap">
                {social.map((link, index) => (
                  <Box key={index} mr={1} mb={1}>
                    <a
                      href={link.url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <MediaImage
                        src={link.src}
                        width={30}
                        height={30}
                        alt={link.image_alt_text}
                      />
                    </a>
                  </Box>
                ))}
              </Box>
            </Box>
            {/** Address */}
            <Box>
              <Box className={classes.logo}>
                <MediaImage
                  src={logo}
                  width={288}
                  height={76}
                  alt={logo_alt_text}
                />
              </Box>
              <Box pt={3} pr={2} className={classes.address}>
                <Typography
                  variant="caption"
                  component="div"
                  color="textPrimary"
                >
                  {address.line1}
                </Typography>
                <Typography
                  variant="caption"
                  component="div"
                  color="textPrimary"
                >
                  {address.line2}
                </Typography>
                <Typography
                  gutterBottom
                  variant="caption"
                  component="div"
                  color="textPrimary"
                >
                  {address.phone && (
                    <Link href={`tel:${address.phone}`}>
                      {address.phone}
                    </Link>
                  )}
                  {address.phone && address.email && <> | </>}
                  {address.email && (
                    <Link href={`mailto:${address.email}`}>
                      {address.email}
                    </Link>
                  )}
                </Typography>
                <Typography variant="caption" color="textPrimary">
                  © Copyright Community Fibre Ltd. All Rights Reserved
                </Typography>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
      {/** SEO Links */}
      {links_for_seo && links_for_seo.length > 0 && (
        <Box p={5} className={classes.seoLinks}>
          <Container>
            <Box>
              {links_for_seo_title &&
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                  className={classes.menuTitle}>
                {links_for_seo_title}
                </Typography>}
              <Box
                display="grid"
                gridTemplateColumns="repeat(4, 1fr)"
                gridColumnGap={8}
                gridRowGap={1}
                gridAutoFlow="row"
              >
                {links_for_seo.map((link, index) => (
                  <Box key={index} className={classes.links}>
                    <Typography variant="caption" color="textPrimary">
                      <Link href={link.url} color="textPrimary">
                        {link.text}
                      </Link>
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Container>
        </Box>
      )}
    </Box>
  )
}
